import ReactDOM from 'react-dom/client'
import { PortalProviders } from '@portals/shared/PortalProviders'
import { AdminPortal } from '@portals/admin/AdminPortal'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <PortalProviders portal="admin">
    <AdminPortal />
  </PortalProviders>
)
